import React from 'react';
import DirectusSDK from '@directus/sdk-js';
import HeadlessConfig from '../config/headless';

const client = new DirectusSDK();
client.login({
  url: HeadlessConfig.url,
  project: HeadlessConfig.project,
  email: HeadlessConfig.email,
  password: HeadlessConfig.password
});

export default class EntfernenView extends React.Component {
  componentWillMount() {
    client.updateItem('bnb_angebote', this.props.match.params.id, {
      active: 0
    }).then(data => {
      window.location.href = "/homestay/eintrag-geloescht/";
    }).catch(err => {
      window.location.href = "/homestay/fehler/";
    })
  }

  render() {
    return null;
  }
}